<template>
  <!-- 团建主题 -->
  <div class="themeList">
    <heads></heads>
    <div class="container">
        <!--搜索区-->
        <div class="container-top" ref="contentTopRef">
          <div class="search-wrapper">
            <div class="search-input-wrapper">
              <input
                type="text"
                class="search-input"
                v-model="searchVal"
                @keyup.enter="toSearch"
                placeholder="您可以输入产品名称或目的地快速上搜索"
              />
              <div class="search-btn" @click="tosearch">
                <span class="el-icon-search"></span>
                搜索
              </div>
            </div>
          </div>
          <div class="search-select-item"></div>
          <div class="search-select-item">
            <span class="select-sider">团建主题</span>
            <div class="select-tabs">
              <ul>
                <li
                  @click="themeMoreSelect()"
                  :class="
                    selectContains(themeSelectIndexList, -1) ? 'select' : ''
                  "
                >
                  不限
                </li>
                <li
                  v-for="(item, index) in themeList"
                  :key="index"
                  @click="themeMoreSelect(item)"
                  :class="
                    selectContains(themeSelectIndexList, item.themeId)
                      ? 'select'
                      : ''
                  "
                >
                  {{ item.themeName }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      <div class="container-bottom">
        <div class="theme-list" style="margin-top: 20px">
          <div
            class="theme-item"
            @click="toDetail(item.id)"
            v-for="item in pageArray"
            :key="item.id"
          >
            <div class="theme-item-pic">
              <img :src="item.image" alt />
            </div>
            <div class="theme-item-text">
              <div class="tags title">
                {{ item.title }}
              </div>
              <!-- <div class="tags theme" v-if="item.themeList">
                      <span
                        v-for="(item, index) in item.themeList"
                        :key="index"
                        >{{ item }}</span
                      >
              </div>               -->

            </div>
            <!-- <div class="price">
                  {{ item.price }}
            </div>
            <div class="type">
                      <span v-if="item.typeName">{{ item.typeName }}</span
                      ><span class="separator" v-if="item.typeName && item.day"
                        >|</span
                      ><span v-if="item.day"
                        >{{ item.day }}天{{ item.night }}晚</span
                      ><span
                        class="separator"
                        v-if="item.numberMin || item.numberMax"
                        >|</span
                      ><span v-if="item.numberMin || item.numberMax"
                        >{{ item.numberMin }}-{{ item.numberMax }}人</span
                      >
                    </div> -->
          </div>
          <div
            v-if="pageArray.length%3==2"
            class="theme-item theme-item-empty"
          >
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <homeFoots></homeFoots>
   <homeBottomImage style="z-index:1000"></homeBottomImage>
   <quickContact :message="quickContactMessage"></quickContact>
  </div>
</template>
<script>
import heads from "@/components/comment/heads.vue";
import homeBottomImage from "@/components/comment/homeBottomImage.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import quickContact from "@/components/comment/quickContact.vue";
import { handlePicPlusPre } from "@/util/util.js";
import axios from "axios";
import wxShare from "@/common/wx_share.js";
export default {
  name: "themeList",
  data() {
    return {
      pageNum: 1,
      pageSize: 12,
      total: 0,
      nav: 0,
      navArray: ["全部", "北京", "上海", "杭州"],
      id: 0,
      pageArray: [],
      bannerArray: [],
      loading: false,
      quickContactMessage:{
        type:1
      },
      searchVal:null,
      themeSelectIndexList:[-1],
      themeList:[]
    };
  },
  components: {
    heads,
    homeFoots,
    quickContact,
    homeBottomImage
  },
  computed: {
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },
    // nav() {
    //   return this.$route.params.id;
    // }
  },
  methods: {
    handlePicPlusPre,
    getNav(index) {
      this.nav = index;
    },
    toDetail(id) {
      window.open("/#/teamBuildingDetail?id="+id)
    },
    // -- 分页方法
    handleCurrentChange(val) {
      this.loading = true;
      this.dispatchQuery();
    },
    handleSizeChange(val) {
      console.log("当前页:" + val);
    },
    getTbListByTitle() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        title: this.searchVal,
        departCityId:this.getLocationSiteCityId?this.getLocationSiteCityId:5,
        tbType: "4",
      };
      axios
        .get(`/api/tb/tbList`, {
          params,
        })
        .then((res) => {
          console.log(res);
          if (res.data && res.data.code == 200) {
            this.total = res.data.total;
            this.pageArray = res.data.rows;
            if (this.pageArray) {
              this.pageArray.forEach((pageItem) => {
                if (pageItem.image) {
                  pageItem.image = handlePicPlusPre(
                    pageItem.image
                  );
                  pageItem.image = pageItem.image[0];
                }
                if (pageItem.themeNames) {
                    let themeList = pageItem.themeNames.split(" ");
                    pageItem.themeList = themeList;
                }
              });
            }
          }
        });
        this.wxShareForTheme();
    },
    // 查询调度方法
    async dispatchQuery(){
      if(this.searchVal){
        await this.getTbListByTitle();
      }else{
        await this.getTbList();
      }
    },
    getTbList() {
      let themeIds = "";
      this.themeSelectIndexList.forEach((theme) => {
        if (theme != -1) {
          if (themeIds != "") {
            themeIds += "," + theme;
          } else {
            themeIds = theme;
          }
        }
      });
      if (themeIds == "") {
        themeIds = null;
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        themeIds:themeIds,
        tbType: "4",
      };
      axios
        .get(`/api/tb/tbList`, {
          params,
        })
        .then((res) => {
          console.log(res);
          if (res.data && res.data.code == 200) {
            this.total = res.data.total;
            this.pageArray = res.data.rows;
            if (this.pageArray) {
              this.pageArray.forEach((pageItem) => {
                if (pageItem.image) {
                  pageItem.image = handlePicPlusPre(
                    pageItem.image
                  );
                  pageItem.image = pageItem.image[0];
                }
                if (pageItem.themeNames) {
                    let themeList = pageItem.themeNames.split(" ");
                    pageItem.themeList = themeList;
                }
              });
            }
          }
        });
        this.wxShareForTheme();
    },
   // 判断数组是否包含
    selectContains(array, index) {
      // debugger
      console.log("---|---");
      return array.indexOf(index) > -1 ? true : false;
    },


    // 获取团建主题
    getThemeList(){
      axios.get("/api/tb/themeList").then((res) => {
          this.themeList = res.data.data;
      });
    },
     // 团建主题多选
     themeMoreSelect(item) {
      // 如果为不限，清除其他
      if (!item) {
        this.themeSelectIndexList = [-1];
        // 搜索
        // this.searchMode = 1;
        this.getTbList();
        return;
      }
      if (this.selectContains(this.themeSelectIndexList, item.themeId)) {
        let position = this.themeSelectIndexList.indexOf(item.themeId);
        this.themeSelectIndexList.splice(position, 1);
        // 当全部都点掉时，补充不限进列表
        if (this.themeSelectIndexList.length < 1) {
          this.themeSelectIndexList = [-1];
        }
      } else {
        if (this.selectContains(this.themeSelectIndexList, -1)) {
          this.themeSelectIndexList.splice(0, 1);
        }
        this.themeSelectIndexList.push(item.themeId);
      }
      // 开始请求
      this.getTbList();
      return;
    },
     // 团建主题多选
     themeMoreSelect2(item) {
      // 如果为不限，清除其他
      if (!item) {
        this.themeSelectIndexList = [-1];
        // 搜索
        // this.searchMode = 1;
        return;
      }
      if (this.selectContains(this.themeSelectIndexList, item.themeId)) {
        let position = this.themeSelectIndexList.indexOf(item.themeId);
        this.themeSelectIndexList.splice(position, 1);
        // 当全部都点掉时，补充不限进列表
        if (this.themeSelectIndexList.length < 1) {
          this.themeSelectIndexList = [-1];
        }
      } else {
        if (this.selectContains(this.themeSelectIndexList, -1)) {
          this.themeSelectIndexList.splice(0, 1);
        }
        this.themeSelectIndexList.push(item.themeId);
      }
      // 开始请求
      return;
    },
     // 微信分享接口调用
     wxShareForTheme(){
    // 微信分享
    // if (wxShare.is_wx()) {
    if (true) {
      let url = window.location.href
      if(this.searchVal || (this.themeSelectIndexList && this.themeSelectIndexList[0]!=-1)){
        if(url.indexOf("themeList?") == -1){
          url += "?";
        }else{
          url = url.split("themeList?")[0]+"themeList?"
        }
        // 补齐链接
        if(this.searchVal == null){
          let themeIds = "";
        this.themeSelectIndexList.forEach((theme) => {
          if (theme != -1) {
            if (themeIds != "") {
              themeIds += "," + theme;
            } else {
              themeIds = theme;
            }
          }
        });
          url += "&pageNum="+ this.pageNum
          +"&themeIds="+themeIds
        }else{
          url += "&pageNum="+ this.pageNum
          +"&search="+this.searchVal
        }
      }
      console.log("wx-url",url)
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${url}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
    tosearch() {
      this.loading = true;
      this.searchMode = 2;
      this.getTbListByTitle();
    },
  },
  mounted() {
    // 微信分享
    
  },
  created() {
     if (this.$route.query) {
      console.log("this.$route.query");
      console.log(this.$route.query);
      const query = this.$route.query;
      if (query.search) {
        this.searchVal = this.$route.query.search;
      }
      if (this.$route.query.themeIds) {
        let themeIds = this.$route.query.themeIds;
        let themeIdItem = {};
        const themeIdArray = themeIds.split(",") ;
        themeIdArray.forEach(themeId=>{
          themeIdItem = {
            themeId: Number(themeId),
          };
          this.themeMoreSelect2(themeIdItem)
        })
      }
      this.dispatchQuery(); 
     }
     this.getThemeList();
  },

   
  destroyed() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  },
};
</script>
<style scoped>
.container {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 1060px;
  background-color: #fff;
}
.container-top {
  background-color: #f8f8f8;
  width: 100%;
}

.search-wrapper {
  width: 100%;
  /* position: absolute; */
  display: flex;
  justify-content: left;
  bottom: 0px;
  z-index: 9;
  box-sizing: border-box;
  color: #fff;
  padding: 20px 20px;
  font-size: 14px;
  padding: 20px 20px;

  /* background: rgba(0, 0, 0, 0.38); */
}
.search-input-wrapper {
  display: flex;
  border-radius: 4px;
  padding: 5px;
  margin-top: 8px;
  position: relative;
  width: 800px;
}
.search-input {
  flex: 1;
  padding: 0 10px;
  /* border: 0; */
  border-radius: 4px;
  line-height: 45px;
  border: 1px solid #cccccc;
}
.search-btn {
  background: #359ff8;
  padding: 12px 25px;
  border-radius: 0 4px 4px 0;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}
.search-btn:hover {
}
.search-select-item {
  padding: 6px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.search-select-item .select-sider {
  display: block;
  width: 90px;
  padding-left: 30px;
  left: 23px;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #545658;
  text-align: left;
}
.search-select-item .select-tabs {
  overflow: hidden;
  width: 860px;
}

.search-select-item .select-tabs ul {
  list-style: none;
}
.search-select-item .select-tabs ul li {
  cursor: pointer;
  margin: 0 6px;
  padding: 0 12px 6px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  border: 1px solid transparent;
  font-size: 14px;
  color: #515255;
  border-radius: 15px;
}
.search-select-item .select-tabs ul .select {
  cursor: pointer;
  margin: 0 6px;
  padding: 0 12px;
  height: 30px;
  display: inline-block;
  font-weight: 700;
  color: #fff;
  background-color: #359ff8;
  line-height: 30px;
  border: 1px solid transparent;
  font-size: 14px;
  border-radius: 15px;
}
.search-item .select-tabs {
  cursor: pointer;
  margin: 0 6px;
  padding: 0 12px;
  height: 30px;
  display: inline-block;
  font-weight: 700;
  color: #fff;
  background-color: #359ff8;
  line-height: 30px;
  border: 1px solid transparent;
  font-size: 14px;
  color: #515255;
  border-radius: 15px;
}
.select-items .select-tabs ul .select {
  color: #088dfa !important;
  font-weight: 100 !important;
  background-color: #c2e2fd;
}

.container-bottom {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 1060px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}
.container-bottom .nav {
  padding: 34px 0;
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
  text-align: center;
  width: 342px;
  margin: 0 auto;
}
.container-bottom .nac-active {
  font-weight: bold;
}
.nav span {
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
  /* margin:0px 20px; */
}
.nav-item {
  padding: 0 20px;
}
.nav .underline {
  line-height: 10px;
  border-bottom: 2px solid #359ff8;
}
.theme-list {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
}
.theme-list .theme-item {
  width: 310px;
  height: 240px;
  background: #fff;
  margin-bottom: 20px;
  border: 1px solid #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.theme-list .theme-item:hover {
  cursor: pointer;
  box-shadow: 10px 10px 20px rgb(0 0 0 / 10%);
}
.theme-list .theme-item .theme-item-pic {
  width: 100%;
  overflow: hidden;
  height: 180px;
}
.theme-list .theme-item .theme-item-pic img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  transition: all 0.2s ease-in-out;
}
.theme-list .theme-item .theme-item-text {
  position: relative;
}
.theme-item-text .title {
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  height: 40px;
  line-height: 20px;
  
}
.theme-item-text .tags {
  font-size: 15px;
  color: #222;
  padding: 0px 12px;
  margin-top: 5px;
}
.theme-item-text .theme {
  width: 100%;
  overflow: hidden;
}
.theme-item-text .theme span{
  padding: 0 6px;
  background: #f5f5f5;
  border-radius: 2px;
  height: 28px;
  line-height: 28px;
  display: inline-block;
  font-size: 12px;
  color: #5a5a5a;
  text-align: center;
  margin-right: 5.8px;
}

.theme-item  .price {
  display: inline;
  font-weight: 700;
  font-size: 24px;
  color: #f9541c;
  position: absolute;
  right: 10px;
  bottom: 5px;
}
.theme-item  .type {
  position: absolute;
  left: 10px;
  bottom: 5px;
}
.theme-item .type span {
  color: #5a5a5a;
  font-size: 14px;
  overflow: hidden;
}
.theme-item .type .separator {
  padding: 0px 5px;
}
.theme-item  .price::after {
  content: "元起/人";
  font-size: 12px;
  color: #666;
}
.pagination {
  margin-bottom: 10px;
}
.theme-item-empty{
  opacity: 0;
  cursor:auto!important;
}
</style>




// WEBPACK FOOTER //
// src/components/themeList.vue